export default __webpack_public_path__ + "static/media/or-2.2dc36d4c.jpg";